export enum AvatarVariant {
	STATUS = 'status',
}
